import { useContext } from "react"

import { ProductConfiguratorProps } from "../ProductConfigurator"
import {
  ProductConfiguratorContext,
  useProductConfiguratorContextValue
} from "./ProductConfiguratorContext"

export function ProductConfiguratorStepsFallbackProvider({
  model,
  children
}: {
  model: ProductConfiguratorProps
  children: React.ReactNode
}) {
  const inheritedContext = useContext(ProductConfiguratorContext)
  const ownContext = useProductConfiguratorContextValue(model)

  return (
    <ProductConfiguratorContext.Provider value={inheritedContext ?? ownContext}>
      {children}
    </ProductConfiguratorContext.Provider>
  )
}
